// Filename: App.js

import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./HomePage/Home";
import Blog from "./BlogPage/BlogNav";
import CustomCursor from "../../src/components/cursor"; // Import the CustomCursor component

class App extends Component {
  render() {
    return (
      <Router>
        {/* Add the CustomCursor */}
        <CustomCursor />

        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/blog/:blogId" element={<Blog />}></Route>
        </Routes>
      </Router>
    );
  }
}

export default App;